import { render, staticRenderFns } from "./detail_p.vue?vue&type=template&id=a4fb1fa2&scoped=true"
import script from "./detail_p.vue?vue&type=script&lang=js"
export * from "./detail_p.vue?vue&type=script&lang=js"
import style0 from "./detail_p.vue?vue&type=style&index=0&id=a4fb1fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fb1fa2",
  null
  
)

export default component.exports